export const scrollTop = (options = null) => {
  let o = { top: 0, left: 0 }
  if (options && options.behaviour) o = {...o, behavior: options.behaviour}
  window.scroll(o)
}
